/* src/app/webtree-website/ai-resume-form/ai-resume-form.component.scss */
.form-section {
  background-color: #FBFBFB;
}
.form-section .text-steps {
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 5px;
  color: #484b59;
}
.form-section .step-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #484b59;
}
.form-section .ai-screen-form-input {
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  font-size: 14px;
  line-height: 1.2;
  padding: 6px 12px;
  height: 36px;
  width: 100%;
  color: #484b59;
}
.form-section .ai-screen-form-input:focus {
  outline: none;
  border: 1px solid #2E93A1;
}
.form-section textarea.ai-screen-form-input {
  padding: 12px;
  border-radius: 12px;
  min-height: 150px;
  height: calc(100% - 80px);
  color: #484b59;
}
.form-section textarea.ai-screen-form-input:focus {
  outline: none;
  border: 1px solid #2E93A1;
}
.form-section .ats-upload-btn {
  width: 100%;
  border: dashed 0.5px #2e93a1;
  color: #2e93a1;
  display: flex;
  box-sizing: border-box;
  position: relative;
  background-color: #ECF0F4;
  border-radius: 5px;
  height: 150px;
  margin-bottom: 10px;
}
.form-section .learnmorebox {
  background:
    linear-gradient(
      90deg,
      rgba(255, 245, 134, 0) 2.65%,
      #FFF586 100%);
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 15px;
}
.example-list {
  width: 100%;
  max-width: 100%;
  border: none;
  min-height: 60px;
  display: block;
  background: #FBFBFB;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 30px;
}
.example-box {
  padding: 12px 12px;
  border-bottom: none;
  color: #484b59;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  margin-bottom: 12px;
}
.example-box:focus-within {
  box-shadow: 0px 4px 8px 0px #e8e8e8;
}
.example-box:hover {
  box-shadow: 0px 4px 8px 0px #e8e8e8;
}
.example-box .wc-form-control {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.example-box .wc-form-control:focus {
  border-color: #2E93A1;
}
.cdk-drag-preview {
  border: none;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-placeholder {
  opacity: 0;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.crtiteria-input {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  font-size: 14px;
  line-height: 1.2;
  padding: 10px 10px;
  height: auto;
  width: 100%;
  color: #969696;
}
.click-to-more-criteria-btn {
  background: rgba(46, 147, 161, 0.0705882353);
  border: 1px dashed #2E93A1;
  color: #2E93A1;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  cursor: pointer;
  padding: 5px;
  text-align: center;
}
.ai-suggestion {
  background:
    linear-gradient(
      90deg,
      #FFF9FC 0%,
      #FFEFF6 53.85%);
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 6px 10px;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}
.ai-suggestion:hover {
  border: 1px solid #E54F7A;
}
.ai-suggestion .plus {
  font-size: 18px;
  font-weight: 500;
  color: #E54F7A;
  margin-right: 10px;
}
.ai-suggestion .ai-screening-chips {
  display: flex;
  align-items: flex-start;
}
.bulkparse-upload {
  width: 100%;
  height: 158px;
  padding: 50px 39px 47px;
  border: dotted 1px #2e93a1;
  background-color: #ecf0f4;
}
.disable-btn {
  background: #f2f2f2 !important;
  border: none !important;
  color: #6E6E6E !important;
  cursor: not-allowed !important;
}
.screener-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
/*# sourceMappingURL=ai-resume-form.component-MJWKYUAC.css.map */
